import React, { useEffect, useState } from "react";
import Inner_Footer_Text_Component from "../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllPreventMoneyLaundering } from "../../utils/apis/content/content";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Preventing_Money_Laundering = () => {

    const navigate = useNavigate();

  const [preventingMoneyLaundering, setPreventingMoneyLaundering] = useState(
    ""
  );
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getMoneyLaundering = async () => {
    const res = await getAllPreventMoneyLaundering();
    if (res?.success) {
      setPreventingMoneyLaundering(res.data);
    }
  };

  useEffect(() => {
    getMoneyLaundering();
  }, []);
  return (
    <section className="Preventing_Money_Laundering About_Profile">
      <div className="heading_div">
        <div className="row">
          <div className="col-8">
            <p className="info_page_title">Preventing Money Laundering</p>
          </div>
          <div className="col-4 text-end">
            <FontAwesomeIcon
              className="colpa-close"
              icon={faXmark}
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      </div>

      <div className="info_div">
        <p className="info_text">
          {htmlToReactParser.parse(preventingMoneyLaundering?.name)}
        </p>
      </div>

      <div className="footer_div">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default Preventing_Money_Laundering;
